import { render, staticRenderFns } from "./ShiftPeriodViewTable.vue?vue&type=template&id=4923a4ed&scoped=true&"
import script from "./ShiftPeriodViewTable.vue?vue&type=script&lang=js&"
export * from "./ShiftPeriodViewTable.vue?vue&type=script&lang=js&"
import style0 from "./ShiftPeriodViewTable.vue?vue&type=style&index=0&id=4923a4ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4923a4ed",
  null
  
)

export default component.exports